import React, { useLayoutEffect, useRef } from 'react';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';

import Line from './Line';

import { FEWER_LINES_SIGNAL, MORE_LINES_SIGNAL } from 'components/play/Types/Constants';
import { getNonEmptyLines } from 'components/play/helpers/linesHelper';
import useLinesHelper from 'components/play/helpers/useLinesHelper';
import useLinesManageButtonClick from 'components/play/helpers/useLinesManageButtonClick';

export default function KenoPicker() {
    const { lottery, lines, removeLine, addEmptyLine } = useLinesHelper();
    const autoAddEmptyLine = useRef<boolean>(true);

    useLayoutEffect(() => {
        if (
            autoAddEmptyLine.current &&
            lines.length < lottery.maxLinesPerTicket &&
            lines.length === getNonEmptyLines(lines).length
        ) {
            addEmptyLine();
        }

        autoAddEmptyLine.current = true;
    }, [lines]);

    useLinesManageButtonClick((buttonSignal) => {
        if (buttonSignal === MORE_LINES_SIGNAL && lines.length < lottery.maxLinesPerTicket) {
            addEmptyLine();
        }
        if (buttonSignal === FEWER_LINES_SIGNAL && lines.length > 0) {
            // if there is more than one line you can remove the last one
            autoAddEmptyLine.current = lines.length === 1;
            removeLine(lines.length - 1);
        }
    });

    const baseView = () => (
        <div className="keno-lines user-guide-play-picker">
            {lines.map((line, index) => (
                <Line key={`${index + 1}`} lineNumbers={line} lineIndex={index} stake={1} />
            ))}
        </div>
    );

    const defaultView = () => (
        <div className="keno-lines form-mobile">
            {lines.map((line, index) => (
                <Line key={`${index + 1}`} lineNumbers={line} lineIndex={index} stake={1} />
            ))}
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}
